import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Page, PageHeader, Page404 } from '../src/ui'
import { SellersPage } from '../src/modules/users/list/pages'
import { fetchCountries } from '../src/modules/geoObjects/countries/actions'
import { fetchCitiesByCountryWithinRegions, setCitiesByCountryWithinRegions } from '../src/modules/geoObjects/cities/actions'
import { fetchLocations, setLocations } from '../src/modules/geoObjects/locations/actions'
import { fetchUsers, setUserType, setJobFieldSpecification } from '../src/modules/users/list/actions'
import { getUserType } from '../src/modules/users/list/selectors'
import { capitalize, deepCopy } from '../src/utils/Utils'
import { globalOptions } from '../src/core/constants'
import { fetchServices } from '../src/modules/ads/services/actions'
import { fetchServiceTypes, setServiceTypes } from '../src/modules/ads/serviceTypes/actions'
import { fetchSpecifications, fetchCategories } from '../src/modules/categories/actions'
import initialState from '../src/modules/redux/initialState'
import config from '../src/config/config.yaml'

class UsersPage extends React.Component {
  static async getInitialProps ({store, query, isServer, req}) {
    store.dispatch(setUserType(query.parentUserType))
    console.log('query', query)
    let isPageExists = false
    const state = store.getState()
    const selectedUserType = getUserType(state)
    const selectableUserTypes = state.common.selectableUserTypes

    if (selectedUserType) isPageExists = true

    if (isPageExists) {
      let queryParams = {}

      if (query) queryParams = { ...query }

      let types = []
      let jobTypeSpecification = null

      switch (selectedUserType.seo) {
        case 'web-prodavnica':
          if (selectableUserTypes && selectableUserTypes.length) {
            types = selectableUserTypes.filter(type =>
              ['web-prodavnica', 'prodavnica-djelova'].includes(type.seo)
            ).map(type => type.id)
          }
          break
        case 'auto-moto-nautika':
          if (selectableUserTypes && selectableUserTypes.length) {
            const parentId = selectedUserType.id
            types = selectableUserTypes.filter(type => type.seo !== 'korisnik' && type.parent === parentId).map(type => type.id)
          }
          break
        case 'nekretnine':
          if (selectableUserTypes && selectableUserTypes.length) {
            const parentId = selectedUserType.id
            types = selectableUserTypes.filter(type => type.seo !== 'korisnik' && type.parent === parentId).map(type => type.id)
          }
          break
        case 'servis-i-usluga':
          if (selectableUserTypes && selectableUserTypes.length) {
            types = selectableUserTypes.filter(type => type.seo === 'servis-i-usluga').map(type => type.id)
          }
          break
        case 'poslodavac':
          if (selectableUserTypes && selectableUserTypes.length) {
            types = selectableUserTypes.map(type => type.id)

            const findJobCategory = state.categories.parentCategories.find(cat => cat.seo === 'poslovi')

            if (findJobCategory) await store.dispatch(fetchSpecifications(findJobCategory.id))

            const jobCategorySpecs = store.getState().categories.specifications

            if (Array.isArray(jobCategorySpecs) && !state.user.list.jobFieldSpecification) {
              const findJobFieldSpecification = jobCategorySpecs.find(spec => {
                return spec && spec.specification && spec.specification.title === 'Oblast zaposlenja'
              })

              if (findJobFieldSpecification) store.dispatch(setJobFieldSpecification(findJobFieldSpecification))
            }

            if (Array.isArray(jobCategorySpecs)) {
              const findJobTypeSpecification = jobCategorySpecs.find(spec => {
                return spec && spec.specification && spec.specification.title === 'Tip oglasa'
              })

              if (findJobTypeSpecification) jobTypeSpecification = findJobTypeSpecification
            }
          }
          break
        default: break
      }
      
      const limit = globalOptions.usersCountPerPage
      const page = 1
      const {userType, parentUserType, ...rest} = queryParams
      let requestParams = { types, limit, page }

      if (queryParams) {
        if (queryParams.djelatnost) {
          requestParams = { page, ...rest, limit, types: [Number(queryParams.djelatnost)] }
        } else {
          requestParams = { page, ...rest, limit, types }
        }

        if (queryParams.specifications) {
          try {
            requestParams.specifications = JSON.parse(queryParams.specifications)
          } catch (err) {
            requestParams.specifications = queryParams.specifications
          }
        }
      }

      if (selectedUserType && selectedUserType.seo === 'poslodavac' && jobTypeSpecification) {
        if (requestParams.specifications) {
          requestParams.specifications.push({
            id: jobTypeSpecification.specification.id,
            value: 'Nudim posao'
          })
        } else {
          requestParams.specifications = [{
            id: jobTypeSpecification.specification.id,
            value: 'Nudim posao'
          }]
        }
      }

      await store.dispatch(fetchUsers(requestParams, []))

      await store.dispatch(fetchCategories())

      await store.dispatch(fetchCountries())
      if (queryParams.country) {
        const country = Number(queryParams.country)
        await store.dispatch(fetchCitiesByCountryWithinRegions(country))
      } else {
        store.dispatch(setCitiesByCountryWithinRegions({}))
      }
      if (selectedUserType.seo === config.userTypes.serviceProviderSeo) {
        await store.dispatch(fetchServices(null, true))
        const service = isServer ? req.query.service : query.service
        if (service) {
          await store.dispatch(fetchServiceTypes({service: Number(service)}))
        } else {
          store.dispatch(setServiceTypes([]))
        }
      }
      if (queryParams.city) {
        await store.dispatch((fetchLocations(Number(queryParams.city))))
      } else {
        store.dispatch(setLocations([]))
      }
    }

    return {
      title: isPageExists
        ? `${capitalize(selectedUserType && selectedUserType.namePlu)} | ${config.pages.defaultTitle}`
        : config.pages.notFoundTitle,
      userType: selectedUserType,
      isPageExists,
      state: UsersPage.getPageState(store, isPageExists)
    }
  }

  static getPageState (store, isPageExists = false) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.list = currentState.user.list
      state.user.listSidebar = currentState.user.listSidebar

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = !isPageExists
      state.common.userTypes = currentState.common.userTypes
      state.common.selectableUserTypes = currentState.common.selectableUserTypes
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.groups = currentState.groups

      state.categories = currentState.categories

      if (isPageExists) {
        state.geoObjects.countries = currentState.geoObjects.countries
        state.geoObjects.regions = currentState.geoObjects.regions
        state.geoObjects.cities = currentState.geoObjects.cities
        state.geoObjects.locations = currentState.geoObjects.locations

        state.ads.services = currentState.ads.services
        state.ads.serviceTypes = currentState.ads.serviceTypes
        state.ads.sms = currentState.ads.sms
      }

      state.form = currentState.form

      state.cart = currentState.cart
      state.orders = currentState.orders
    }
    return state
  }

  render () {
    const {userType, isPageExists} = this.props

    let title = userType && userType.namePlu

    return isPageExists
      ? <Page>
        <PageHeader>{capitalize(title)}</PageHeader>
        {config.userTypes.businessUsersSeos.includes(userType.seo) ||
          userType.seo === config.userTypes.serviceProviderSeo ? <SellersPage /> : null}
      </Page>
      : <Page404 />
  }
}

UsersPage.propTypes = {
  userType: PropTypes.shape({
    seo: PropTypes.string.isRequired,
    namePlu: PropTypes.string.isRequired
  }).isRequired,
  isPageExists: PropTypes.bool.isRequired
}

UsersPage.defaultProps = {
  isPageExists: false
}

export default connect(null)(UsersPage)
